import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthUser {
  uid: string;
  email: string;
  emailVerified: boolean;
  displayName: string;
  isAnonymous: boolean;
  photoURL: string;
  providerId: string;
  accessToken: string | null; // 🔥 NEW
}

interface AuthState {
  user: AuthUser | null;
  authReady: boolean,
}

const initialState: AuthState = {
  user: null,
  authReady: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser: (state, action: PayloadAction<AuthUser | null>) => {
      state.user = action.payload;
      state.authReady = true;
    },
    updateAccessToken: (state, action: PayloadAction<string | null>) => {
      if (state.user) {
        state.user.accessToken = action.payload;
      }
    },
    clearAuthUser: (state) => {
      state.user = null;
      state.authReady= false
    },
  },
});

export const { setAuthUser, updateAccessToken, clearAuthUser } =
  authSlice.actions;
export default authSlice.reducer;
